import { schemaTypes } from '../../../constants/constants'
import ReportAPIs from '../../../APIs/ReportAPIs';
import { JSONToCSVConvertor } from '../../../helpers/helperFunctions'
import _ from 'lodash';
import moment from 'moment';
import { changeVehicle } from './historyReport/historyReport';
import { bmsStateMap } from './canDataReport';
import { useEffect } from 'react';

export const dateFormat = "DD-MMM-YYYY HH:mm";
window.dumpTime = {starttime: null, endtime: null}
let meta = [{ "battery_voltage": 'V' },
{ "current": 'A' },
{ "soc": '%' },
{ "controller_temperature": '°C' },
{ "motor_temperature": '°C' },
{ "speed": 'Kmph' },
{ "battery_current": 'A' },
{ "odometer": 'km' },
{ "soh": '%' },
{ "battery_temperature": '°C' },
{ "engine_speed": 'rpm' },
{ "vehicle_speed": 'kmph' },
{ "cell_temperature_":'°C'},
{ "cell_voltage_":"V" }
]

const parameters = [
    "acceleration_pedal_position",
    "auxiliary_voltage",
    "battery_id",
    "battery_temp",
    "battery_voltage",
    "bms_fault_01",
    "bms_fault_02",
    "bms_fault_03",
    "bms_fault_04",
    "bms_fault_05",
    "bms_fault_06",
    "bms_fault_07",
    "bms_fault_08",
    "bms_fault_status",
    "bms_status",
    "bms_warning_01",
    "bms_warning_02",
    "bms_warning_03",
    "bms_warning_04",
    "bms_warning_05",
    "bms_warning_06",
    "bms_warning_07",
    "bms_warning_status",
    "brake_pedal_position",
    "charger_faults",
    "charge_plug_status",
    "charge_status",
    "controller_temperature",
    "current",
    "drive_mode",
    "dte",
    "ecuid_part1",
    "ecuid_part2",
    "energy",
    "icl_limphomereq",
    "icl_tel_encryptionfailcnt",
    "icl_tel_genencryptionstate",
    "icl_tel_key",
    "icl_tel_seed",
    "icl_vehiclemodestatus",
    "immobilization_status",
    "key_connection",
    "main_stand_status",
    "maximum_cell_voltage",
    "mcu_ac_rms_current",
    "mcu_dc_current",
    "mcu_dc_voltage",
    "mcu_enable",
    "mcu_fault_01",
    "mcu_fault_02",
    "mcu_fault_03",
    "mcu_fault_03_01",
    "mcu_fault_04",
    "mcu_fault_05",
    "mcu_fault_05_01",
    "mcu_fault_status",
    "mcu_fault__status",
    "mcu_limp_home",
    "mcu_regen_status",
    "mcu_tripinfo",
    "minimum_cell_voltage",
    "odometer",
    "sidestandsensor_fault",
    "sidestandstatus",
    "soc",
    "soh",
    "speed_mode",
    "vehicle_speed"
  ];

const isToolDisabled = () => {
    // console.log(schema)
    return !schema.busy
}



const getCANDumpData = (schema, data, store) => {
    if (window.setReportWindowTabBusy) window.setReportWindowTabBusy(schema, true);
    let bmsState = false
    window.graphDataErr = ''
    if (window.InMapForceUpdate) {
        window.InMapForceUpdate();
    }
    let starttime = data.starttime.unix() * 1000;
    let endtime = data.endtime.unix() * 1000;
    if(starttime > endtime){
        store.dispatch({
          type: "ADD_INTOAST",
          data: {
            name: "Start time should be less than the end time",
            content: "Start time should be less than the end time",
            createAt: Date.now(),
            autoClose: 8000,
            showError:true
          },
        });
        if (window.setReportWindowTabBusy) window.setReportWindowTabBusy(schema, false);
        return;
      }

    if (endtime - starttime > 8 * 86400 * 1000) {
        window.setReportWindowTabBusy(schema, false);
        store.dispatch({
            type: "ADD_INTOAST",
            data: {
                name: "You can't select a date range of more than 7 days",
                content: "You can't select date range of more than 7 days",
                createAt: Date.now(),
                autoClose: 8000,
                showError:true
            },
        });
        return;
    }

    const auth = window.getAuth();
    let vehicleno = []
    data.vehicle.map(index => {
        vehicleno.push(index.data.vehicleno)
    })
    if (!vehicleno.length){
        window.graphDataErr = 'Please select a vehicle'
        if (window.InMapForceUpdate) {
            window.InMapForceUpdate();
        }
        if (window.setReportWindowTabBusy) window.setReportWindowTabBusy(schema, false);

        return;
    }
    
    
    let metrics = data.metrics.map((metrics) =>{
        return metrics.name
    })
    if(!metrics.length){
        window.graphDataErr = 'Please Select CAN Data Metrics'
        if (window.InMapForceUpdate) {
            window.InMapForceUpdate();
        }
        if (window.setReportWindowTabBusy) window.setReportWindowTabBusy(schema, false);
        return;
    }
    let body = {
        token: auth.token,
        vehicleno: vehicleno[0],
        starttime: data.starttime.unix() * 1000,
        endtime: data.endtime.unix() * 1000,
        metrics: metrics
    }
    for(let idx in metrics) {
        if(metrics[idx] === "status" && window.selectedVehicles[0] && window.selectedVehicles[0].data.vehicleModel &&
            window.selectedVehicles[0].data.vehicleModel.variant === "Lithion 500") bmsState = true
    }
    if(window.showNoGpsFixData === true){
        body.fixqfilter = false
    }
    const handleFailure = (err) => {
        window.setReportWindowTabBusy(schema, false);
        window.graphDataErr = err.response.data.msg || 'No data to download'
        if (err.response){key
        store.dispatch({
            type: "ADD_INTOAST",
            data: {
                name: "Failed",
                content: "Failed to download",
                createAt: Date.now(),
                autoClose: 8000,
                showError:true
            },
        });
        }
        if (window.InMapForceUpdate) {
            window.InMapForceUpdate();
        }
        }
    const getBMSvalue = (value) => {
        let stateValue = ""
        for(let idx in bmsStateMap){
            if(bmsStateMap[idx].key === value){
                stateValue = bmsStateMap[idx].value
                break
            }
        }
        return stateValue
    }
    const handleSuccess = (resp) => {
        window.graphDataErr = ''
        if (window.InMapForceUpdate) {
            window.InMapForceUpdate();
        }
        let header = [];
        window.CANDUMP = []
        for (let i in resp) {
            if(bmsState && resp[i].status !== null){
                let value = resp[i].status
                resp[i].status = getBMSvalue(value)
            }
            for (let j in resp[i]) {
                if (!header.includes(j)) {
                    header.push(j)
                }
            }
        }
        for (let i in resp) {
            if (Object.keys(resp[i]).length) {
                let obj = {}
                header.map((key, index) => {
                    if(key == 'time'){
                        obj[key] = resp[i][key] != null? moment(resp[i][key]).format('DD-MM-YYYY  HH:mm:ss '):''   
                    }else{key
                        let unit = ''
                        meta.map((data, index) => {
                            if (Object.keys(data)[0] == key) {
                                unit = Object.values(data)[0]
                            }
                        })
                        if(unit){
                            obj[key + '( ' + unit + ' )'] = resp[i][key] != null ? resp[i][key]:''
                        }else{
                            obj[key] = resp[i][key] != null ? resp[i][key]: ''

                        }
                    }
                })
                window.CANDUMP.push(obj)
            } 
        }
        if (window.CANDUMP.length){
            JSONToCSVConvertor(window.CANDUMP, "CAN Data Dump For_" + vehicleno[0] + '_' + moment(Date.now()).format('DD-MMM HH:mm:ss '), false)
        }else{
            window.graphDataErr = 'No data to download'
            if (window.InMapForceUpdate) {
                window.InMapForceUpdate();
            }
        }
        window.setReportWindowTabBusy(schema, false);
    }

    ReportAPIs.getCanDataDump(body).then((resp) => {
        handleSuccess(resp);
    },err=> handleFailure(err))

    if (window.InMapForceUpdate) {
        window.InMapForceUpdate();
    }
}

const schema = {
    key: "bg_can_data_dump_report",
    name: "BG CAN Data Dump",
    toolbar: [
        {
            key: "vehicle",
            type: schemaTypes.MULTI_SELECT,
            singleSelect: true,
            storeData: (state) => {
                return {
                    data: (() => {
                        let newMap = {};
                        for (let idx in state.vehicleMap) {
                            if (idx.indexOf("user") === -1) {
                                newMap[idx] = state.vehicleMap[idx];
                            }
                        }
                        return newMap;
                    })(),
                    name: "vehicleno",
                    id: "vehicleid",
                };
            },
            onItemChange: changeVehicle.bind(this),
            defaultValue: () => {
                return {
                    data: window.selectedVehicles.map((i) => {
                        return i.id;
                    }),
                    updatedAt: window.selectedVehiclesUpdatedAt,
                };
            },
        },
        {
            key: "starttime",
            type: schemaTypes.DATE_PICKER,
            setIfNull: true,
            placeholder: "Start Date",
            model: moment().subtract(1, "days").startOf("day"),
        },
        {
            key: "endtime",
            type: schemaTypes.DATE_PICKER,
            setIfNull: true,
            placeholder: "End Date",
            // model: Date.now()
            model: moment(Date.now()).add(0, "day").startOf("day"),
        },
        {
            key: "metrics",
            type: schemaTypes.MULTI_SELECT,
            storeData: (state) => {
                const metrics = window.metrics ? Object.values(window.metrics) : [];
                // Filter metrics based on match with parameters
                const filteredMetrics = metrics.filter(metric =>
                    parameters.some(param =>
                        param.toLowerCase() === metric.metrics.toLowerCase()
                    )
                );
                if(filteredMetrics.length>0){
                    window.matricsData=false;
                }else{
                    window.matricsData=true;
                }
                return {
                    data: filteredMetrics,
                    name: "metrics",
                    id: "id"
                };
            }
        },
        {
            key: "get_history",
            isDisabled: isToolDisabled,
            type: schemaTypes.BUTTON,
            name: "Download CAN Dump",
            onClick: getCANDumpData
        },

    ],
}

export default schema;